import { useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import {
  getSelectedCase,
  getSingleParty,
  setToggle,
  setToggle_2,
  toggleState,
  toggleState_2,
} from "../../../states/slices/partyInfo.slice";
import { TableComponent } from "../../../components/table/Table";
import {
  CASE_COLUMNS,
  PARTY_COLUMNS,
  PARTY_COLUMNS_view,
  SINGLE_CASE_COLUMNS,
} from "../../../components/table/columns";
import Typography from "../../../components/Typography";
import { ADD_BUTTON, PDF, PLUS, UPLOAD, UPLOAD_ICON } from "../../../assets";
import { formatCurrency, getFormDataHeader } from "../../../utils";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/button";
import { FormInput } from "../../../components/form/Input";
import Modal from "../../../components/UI/modal";
import { Zoom } from "react-reveal";
import PartyInformation from "../../../components/modals/Partinformation";
import CaseInformation from "../../../components/modals/CaseInformation";
import { useDropzone } from "react-dropzone";
import { FaCheck, FaRegTrashAlt } from "react-icons/fa";
import Api from "../../../config";
import toast from "react-hot-toast";

type CaseDocType = {
  id: number;
  title: string;
  document_type: "";
  file: File | null;
};
function ViewCases() {
  const getCase = useAppSelector(getSelectedCase);
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState<File[]>([]);
  const fileInputRef = useRef<any>([]);
  const [requiredPhoto, setRequiredPhoto] = useState("");
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(3);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [blobUrl, setBlobUrl] = useState<any>(null);
  const toggleStatus = useAppSelector(toggleState);
  const toggleStatus_2 = useAppSelector(toggleState_2);
  const singlePartyInfo = useAppSelector(getSingleParty);
  const dispatch = useAppDispatch();
  const [uploadModal, setUploadModal] = useState(false);
  const [caseDocument, setCaseDocument] = useState<CaseDocType[]>([
    {
      id: 1,
      title: "",
      document_type: "",
      file: null,
    },
  ]);
  const handleJoinCase = async () => {
    setLoading(true);
    const formData = new FormData();

    caseDocument.forEach((doc) => {
      if (doc.file) {
        formData.append("file_path", doc.file);
      }
      formData.append("title", doc.title);
      formData.append("type", doc.document_type.toUpperCase());
    });

    try {
      const response = await Api.post(
        `/lawyer/case-folders/${getCase?.id}/add-document`,
        formData,
        getFormDataHeader(),
      );
      if (response) {
        toast.success(response?.data?.message);
        setUploadModal(false);
        setCaseDocument([
          ...caseDocument,
          {
            id: 1,
            title: "",
            document_type: "",
            file: null,
          },
        ]);
        navigate("/non-lawyer/my-files");
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };
  // const handleAddCaseField = () => {
  //   setCaseDocument([
  //     ...caseDocument,
  //     {
  //       id: caseDocument.length,
  //       title: "",
  //       file: null,
  //     },
  //   ]);
  // };

  const handleCaseInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
    index: number,
  ) => {
    const { name, value } = e.target;
    const updatedCaseDoc = caseDocument.map((doc, i) =>
      i === index ? { ...doc, [name]: value } : doc,
    );

    setCaseDocument(updatedCaseDoc);
  };
  const handleFileChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    id: number,
  ) => {
    const file = e.target.files && e.target.files[0];

    const updatedCaseDocs = caseDocument.map((doc, i) =>
      i === id ? { ...doc, file } : doc,
    );

    setCaseDocument(updatedCaseDocs);
  };

  const handleRemoveCaseField = (index: number) => {
    const updatedCaseDoc = caseDocument.map((doc, i) =>
      i === index ? { ...doc, file: null } : doc,
    );

    setCaseDocument(updatedCaseDoc);
  };

  const HandleOpenDoc = () => {
    return (
      <Modal
        open={open}
        close={() => {
          setOpen(false);
          setBlobUrl(null);
        }}
        maxWidth="lg"
      >
        <iframe
          title="PDF Viewer"
          src={blobUrl}
          className="w-full "
          height={900}
        />
      </Modal>
    );
  };

  return (
    <>
      <div className="bg-[#F8F8F9E5]/90  w-full py-2 px-8">
        <Typography textStyle="text-base">{`My Files  / ${getCase?.title}`}</Typography>
      </div>
      <div className="pt-4 pb-8 px-8">
        <Typography textStyle="text-[20px] font-medium">
          Case Folder Information
        </Typography>
        <div className="my-2">
          {getCase ? (
            <TableComponent
              className="rounded-none rounded-t-0"
              DATA={[getCase]}
              COLUMNS={SINGLE_CASE_COLUMNS}
              TITLE=""
              isExport={null}
              isPaginated={null}
              isSearch={null}
              size={size}
              setSize={setSize}
              setPageIndex={() => page + 1}
            />
          ) : (
            <Typography variant="label" textStyle="font-medium text-center">
              No Case Folder Information
            </Typography>
          )}
        </div>
        <Typography textStyle="text-[20px] font-medium">
          Party Information
        </Typography>
        <div className="my-2">
          {getCase?.parties?.length > 0 ? (
            <TableComponent
              className="rounded-none rounded-t-0"
              DATA={getCase?.parties}
              COLUMNS={PARTY_COLUMNS_view}
              TITLE=""
              isExport={null}
              isPaginated={null}
              isSearch={null}
              size={size}
              setSize={setSize}
              setPageIndex={(value: number) => page + 1}
            />
          ) : (
            <Typography variant="label" textStyle="font-medium text-center">
              No Party Information
            </Typography>
          )}
        </div>

        <Typography textStyle="text-[20px] font-medium">
          Uploaded Documents
        </Typography>
        <div className="my-2 lg:flex justify-between items-center flex-wrap ">
          {getCase?.case_documents?.length > 0 ? (
            getCase?.case_documents.map((item: any, index: number) => (
              <>
                <div className="w-full lg:w-[48%]">
                  <div
                    key={index}
                    className="flex justify-between items-center mb-3 border border-gray-200 w-full  p-3  rounded-lg"
                  >
                    <div className="flex justify-start items-center ">
                      <a target="_blank">
                        <img src={PDF} className="h-6 w-6" />
                      </a>
                      <div className="ml-4">
                        <p className=" text-gray-400 text-xs ">
                          Document Title
                        </p>
                        <p className=" text-black font-bold text-sm mt-1">
                          {item?.title}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="mb-4">
                    <a
                      // href={item?.file_path}
                      onClick={() => {
                        setBlobUrl(item?.file_path);
                        setOpen(true);
                      }}
                      target="_blank"
                      className="px-2 py-1 bg-brand_indigo cursor-pointer text-[#fff] text-xs  w-28  rounded-md"
                    >
                      View only
                    </a>
                  </div>
                </div>
              </>
            ))
          ) : (
            <Typography variant="label" textStyle="font-medium text-center">
              No Uploaded Documents
            </Typography>
          )}
        </div>
        <div
          className={`${
            getCase?.case_status?.remark ? "justify-between" : "justify-end"
          } flex  items-end`}
        >
          {getCase?.case_status?.remark && (
            <div className="w-full lg:w-[40%]">
              <Typography textStyle="text-[20px] font-medium">
                Remarks
              </Typography>
              <div className="my-2 flex justify-start items-center ">
                <p className="bg-[#D9D9D91A] overflow-auto min-h-[100px] w-full p-4 text-sm text-gray-600 border border-gray-200">
                  {getCase?.case_status?.remark}
                </p>
              </div>
            </div>
          )}
        </div>
        <div className=" flex justify-between items-end mt-10">
          <Button
            iconClassName="h-[0.9rem] w-3"
            title="Back"
            bgColor={"bg-brand_indigo"}
            onClick={() => navigate("/lawyer/my-files")}
            hoverColor={""}
            textColor={"text-white"}
            className={"py-3 w-44"}
          />
          <Button
            iconClassName="h-[0.9rem] w-3"
            title="Add case document"
            icons={PLUS}
            bgColor={"bg-brand_indigo"}
            onClick={() => setUploadModal(true)}
            hoverColor={""}
            textColor={"text-white"}
            className={"py-3 w-44"}
          />
        </div>
      </div>

      <CaseInformation
        open={toggleStatus_2}
        close={() => dispatch(setToggle_2(false))}
        data={getCase}
      />
      <PartyInformation
        open={toggleStatus}
        close={() => dispatch(setToggle(false))}
        data={singlePartyInfo}
      />
      {HandleOpenDoc()}
      <Modal
        maxWidth={"xs"}
        open={uploadModal}
        close={() => setUploadModal(false)}
      >
        <div className=" h-full px-7 pb-7">
          <span className="text-[20px] font-semibold text-black">
            Upload case documents
          </span>
          {caseDocument.map((docs, index) => (
            <>
              <div className="mt-2 flex-col flex gap-y-2" key={index}>
                <span className="text-[16px] font-semibold">Title</span>
                <input
                  type="text"
                  name="title"
                  className="w-full border border-[#CACACA] rounded outline-none bg-transparent placeholder:text-sm placeholder:text-gray-400 py-4 px-3"
                  placeholder="Enter case title"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleCaseInputChange(e, index)
                  }
                  value={docs.title}
                />
              </div>
              <div className="mt-4 flex-col flex gap-y-2">
                <span className="text-[16px] font-semibold">
                  Document Type <span className="text-red-500">*</span>
                </span>
                <div className="w-full">
                  <input
                    type="text"
                    name={`document_type`}
                    className={`w-full border rounded outline-none bg-transparent placeholder:text-sm placeholder:text-black py-4 px-3`}
                    placeholder="Enter document type"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      handleCaseInputChange(e, index)
                    }
                    value={docs.document_type}
                  />
                </div>
              </div>

              <div className="mt-6 flex flex-col gap-y-2 items-end justify-end">
                <span className="text-[16px] font-semibold flex w-full items-start">
                  Upload documents
                </span>
                {docs.file ? (
                  <div className="w-full h-full border border-[#C7C7CC] p-6 rounded-lg">
                    <div className="flex items-start gap-x-3">
                      <img src={PDF} className="w-[28px] h-[28px]" alt="" />
                      <div>
                        <div className="flex items-start justify-between">
                          <div className="flex items-start gap-x-3">
                            <div className="flex flex-col gap-y-1">
                              <span className="text-sm font-medium text-[#232A35]">
                                {docs.file.name}
                              </span>
                              <span className="text-[#667085] font-normal text-sm">
                                PDF (max 25 MB)
                              </span>
                            </div>
                          </div>
                          <div className="flex items-center h-[16px] w-[16px] justify-center rounded-full bg-[#272755] ">
                            <FaCheck size={10} color="white" />
                          </div>
                        </div>
                        <div className="flex items-center gap-x-3">
                          <div className="w-[268px] h-[8px] bg-[#272755] rounded-lg"></div>
                          <span className="text-nowrap">100 %</span>
                        </div>
                        <div className="flex items-center gap-x-2">
                          <button className="text-sm font-semibold text-[#6C757D]">
                            View
                          </button>
                          <button
                            className="text-sm font-semibold text-[#6C757D]"
                            onClick={() => handleRemoveCaseField(index)}
                          >
                            Delete
                          </button>
                          <button
                            className="text-sm font-semibold text-[#6C757D]"
                            onClick={() =>
                              // @ts-ignore
                              // document
                              //   .querySelector(".file_upload")
                              //   [index].click()
                              fileInputRef.current[index].click()
                            }
                          >
                            Upload another
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    className="w-full h-[126px] cursor-pointer  mt-3 border border-[#EAECF0] flex items-center justify-center flex-col rounded-md"
                    onClick={() =>
                      // @ts-ignore
                      fileInputRef.current[index].click()
                    }
                  >
                    <img
                      src={UPLOAD_ICON}
                      className="w-[40px] h-[40px]"
                      alt=""
                    />

                    <span className="text-[14px] font-semibold">
                      Click to upload{" "}
                      <span className="text-[#667085]">
                        Example receipt.pdf
                      </span>
                    </span>

                    <span className="text-[#667085] text-sm">
                      PDF (max 25mb)
                    </span>
                  </div>
                )}

                <input
                  type="file"
                  accept=".pdf"
                  className="file_upload sr-only"
                  ref={(ref: any) => (fileInputRef.current[index] = ref)}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleFileChange(e, index)
                  }
                />
                {/* <button
                  type="button"
                  onClick={handleAddCaseField}
                  className={`flex justify-end items-end `}
                >
                  <img src={ADD_BUTTON} className="w-[20px] h-[20px] " alt="" />
                </button> */}
              </div>
            </>
          ))}
          <button
            className={`w-full ${
              loading ? "bg-opacity-50 cursor-wait" : "bg-opacity-100"
            } bg-[#272755] text-[17.8px] rounded py-3 mt-9 text-white font-semibold`}
            onClick={handleJoinCase}
          >
            {loading ? "please wait..." : "  Submit"}
          </button>
        </div>
      </Modal>
    </>
  );
}

export default ViewCases;
